//Dependencies............................................
import { Form, Dropdown, Button, Space, Input, Checkbox, Collapse } from 'antd';
import { useEffect, useState } from 'react';
import { ItemType } from 'antd/es/menu/interface';

//Components..............................................

type InitialData_t = {
    baudrate_data_kbps: string,
    baudrate_normal_kbps: string,
    trcv_delay_offset_ms: number,
    fd_enable: boolean
}

export default  function Conf30CanBusConfigField({
    onChange,
    formData,
    errorSchema
    }   :   {
    formData: InitialData_t,
    onChange: (newFormData: any) => void,
    errorSchema: any
    })
{
    const [selectedConfig, setSelectedConfig] = useState<{ [key: string]: any }>({});


    useEffect(() => {
        if(Object.keys(formData).length === 0)
        {
            const initialConfig : InitialData_t = {
                baudrate_data_kbps: '',
                baudrate_normal_kbps: '',
                trcv_delay_offset_ms: 0,
                fd_enable: false
            }
            onChange(initialConfig);
        }else{
            setSelectedConfig(formData);
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setSelectedConfig(formData);
    }, [formData]);

    const baudrateMap: Record<string, string[]> = {
        "125K": ["500K", "833K", "1M", "1M5", "2M"],
        "250K": ["500K", "833K", "1M", "1M5", "2M", "3M", "4M"],
        "500K": ["1M", "2M", "3M", "4M", "5M", "6M7", "8M", "10M"],
        "1000K": ["4M", "8M"],
    };

    const baudrateNormalItems: ItemType[] = [
        { label: '125K', key: '125K' },
        { label: '250K', key: '250K' },
        { label: '500K', key: '500K' },
        { label: '1000K', key: '1000K' }
    ];

    const baudrateDataItems: ItemType[] = (baudrateMap[selectedConfig.baudrate_normal_kbps] || []).map(rate => ({
        label: rate,
        key: rate,
    }));

    const updateNormalBaudrate = (normalRate: string) => {
        const allowedDataRates = baudrateMap[normalRate];

        const updatedConfig = {
            ...formData,
            baudrate_normal_kbps: normalRate,
            baudrate_data_kbps: allowedDataRates.includes(formData.baudrate_data_kbps)
                ? formData.baudrate_data_kbps
                : allowedDataRates[0],
        };

        onChange(updatedConfig);
    };

    const updateConfig = (key: string, value: any) => {
        const updatedConfig = {
            ...formData,
                [key]: value,
        };
        setSelectedConfig(updatedConfig);
        onChange(updatedConfig);
    };

    return (
            <Collapse>
                <Collapse.Panel header="Can Bus Config" key="0" >
                    <Form layout="horizontal">
                        <Form.Item label="Baudrate Normal (kbps)">
                            <Dropdown
                                menu={{
                                    items: baudrateNormalItems,
                                    selectable: true,
                                    onClick: (e) => updateNormalBaudrate(e.key),
                                }}
                            >
                                <Button>
                                    <Space>{selectedConfig.baudrate_normal_kbps || 'Select Baudrate Normal'}</Space>
                                </Button>
                            </Dropdown>
                        </Form.Item>
                        <Form.Item label="Baudrate Data (kbps)">
                            <Dropdown
                                menu={{
                                    items: baudrateDataItems,
                                    selectable: true,
                                    onClick: (e) => updateConfig('baudrate_data_kbps', e.key),
                                }}
                                disabled={!selectedConfig.fd_enable}
                            >
                                <Button disabled={!selectedConfig.fd_enable}>
                                    <Space>{selectedConfig.baudrate_data_kbps || 'Select Baudrate Data'}</Space>
                                </Button>
                            </Dropdown>
                        </Form.Item>
                        <Form.Item
                            label="Transceiver Delay (ms)"
                            validateStatus={errorSchema?.can_bus_config?.trcv_delay_offset_ms ? "error" : ""}
                        >
                            <Input
                                type="number"
                                value={selectedConfig.trcv_delay_offset_ms}
                                style={{
                                    width: '10%',
                                    border: errorSchema?.can_bus_config?.trcv_delay_offset_ms ? '1px solid red' : undefined
                                }}
                                onChange={(e) => updateConfig('trcv_delay_offset_ms', parseInt(e.target.value, 10))}
                            />
                        </Form.Item>
                        <Form.Item label="FD Enable">
                            <Checkbox
                                checked={selectedConfig.fd_enable}
                                onChange={(e) => updateConfig('fd_enable', e.target.checked)}
                            />
                        </Form.Item>
                    </Form>
                </Collapse.Panel>
            </Collapse>
    );
}
